/** Spellbook capability state. Character spell and slot storage is deferred. */
import React from 'react';
import {
  Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader,
  DrawerBody, DrawerFooter, VStack, Text, Button,
} from '@chakra-ui/react';
import { theme as mythboundTheme } from '../../config/theme';

export interface SpellbookDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  characterId?: string;
  characterName?: string;
}

export const SpellbookDrawer: React.FC<SpellbookDrawerProps> = ({
  isOpen, onClose, characterName = 'Unknown Character',
}) => (
  <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
    <DrawerOverlay bg="rgba(0, 0, 0, 0.5)" />
    <DrawerContent
      bg={mythboundTheme.colors.primary.dark}
      borderLeftWidth={2}
      borderLeftColor={mythboundTheme.colors.secondary.purple}
    >
      <DrawerCloseButton color={mythboundTheme.colors.accent.silver} />
      <DrawerHeader
        fontFamily={mythboundTheme.typography.fontFamily.heading}
        color={mythboundTheme.colors.primary.gold}
        borderBottomWidth={1}
        borderBottomColor={mythboundTheme.colors.accent.brown}
      >
        <VStack align="start" spacing={0}>
          <Text>Spellbook</Text>
          <Text fontSize="sm" fontWeight="normal" color={mythboundTheme.colors.accent.silver}>
            {characterName}
          </Text>
        </VStack>
      </DrawerHeader>
      <DrawerBody py={4}>
        <VStack align="start" spacing={3} color={mythboundTheme.colors.accent.silver}>
          <Text fontWeight="bold">Spellbook unavailable</Text>
          <Text>Spells, prepared spells, and spell slots are not stored here yet.</Text>
          <Text>Use your character sheet to reference spells and track spell slots during this session.</Text>
        </VStack>
      </DrawerBody>
      <DrawerFooter borderTopWidth={1} borderTopColor={mythboundTheme.colors.accent.brown}>
        <Button variant="outline" onClick={onClose}
          borderColor={mythboundTheme.colors.accent.silver}
          color={mythboundTheme.colors.accent.silver}
          _hover={{ bg: 'rgba(255, 255, 255, 0.08)' }}
        >Close</Button>
      </DrawerFooter>
    </DrawerContent>
  </Drawer>
);

export default SpellbookDrawer;
